import {CreateGeoService} from './types'

export const createGeoService: CreateGeoService = function createGeoService() {
  return {
    fetchGpsZone() {
      return Promise.resolve('good')
    },
  }
}
